import { createAppAsyncThunk } from "core/src/store/store.types";
import { loadProfile } from "../load-profile/loadProfile.use-case";
import { displayFrontErrorToast } from "core/src/slices/ui/useCases/display-front-error-toast/display-front-error-toast.use-case";
import { homePrefix, TokenKeys } from "etl/types";

export type LoginWithTokenRequest = {
	queryString: string;
};

type LoginWithTokenResponse = {
	awToken: string;
	awRefreshToken: string;
};

/**
 * http://localhost:4000/
 * 
 * Example of queryString:
 * 
 * ?awtoken=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE3NTM0MzQwMTksImV4cCI6MTc1MzQzNzYxOSwicm9sZXMiOlsiUk9MRV9NQU5BR0VSIl0sInVzZXJuYW1lIjoiYnVyZXQuc29waGllQGF1ZGlvd2l6YXJkLmZyIn0.aFEXQ99VpP-9dcdJYURBuOzBeijsi8A5sWWvluq1MKX2r3ENcFpnHMCXwBM7d62XtDprhpxOs8BiDRPFiWe4aUuEI47Tma2XiVj8DqJjUGRe1IgQ3Fkj1TivqttbTsRUN55e-71aRpShsJBrmt2nS9ZHgJJECHG7pisCbYUn5HDGxigvHm2j5ROUcjxA6ulg57fHGzGj2EG0s7qPNt8zUs1k0U1EDAStU4EFf-M9yF7AEno_WJUXOiLVyDbSNXggIUIpsZOabvq9gv4TGx4O7-jTG47PKh1aR7EzxahbblQgwu964qSrqGKd6xTJ-Phl7FgDf_dYsqh5VSJnRwz5Pw&awrefreshtoken=9a5591a3d5f5d622800b1d27a34f60f756d01cde99837d33caa278868101efed968d18ff4ae7b25bed532d3e11189108817364e3f3887de67157c4e72be3068b
 * 
 * http://localhost:4000/?awtoken=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE3NTM0MzQwMTksImV4cCI6MTc1MzQzNzYxOSwicm9sZXMiOlsiUk9MRV9NQU5BR0VSIl0sInVzZXJuYW1lIjoiYnVyZXQuc29waGllQGF1ZGlvd2l6YXJkLmZyIn0.aFEXQ99VpP-9dcdJYURBuOzBeijsi8A5sWWvluq1MKX2r3ENcFpnHMCXwBM7d62XtDprhpxOs8BiDRPFiWe4aUuEI47Tma2XiVj8DqJjUGRe1IgQ3Fkj1TivqttbTsRUN55e-71aRpShsJBrmt2nS9ZHgJJECHG7pisCbYUn5HDGxigvHm2j5ROUcjxA6ulg57fHGzGj2EG0s7qPNt8zUs1k0U1EDAStU4EFf-M9yF7AEno_WJUXOiLVyDbSNXggIUIpsZOabvq9gv4TGx4O7-jTG47PKh1aR7EzxahbblQgwu964qSrqGKd6xTJ-Phl7FgDf_dYsqh5VSJnRwz5Pw&awrefreshtoken=9a5591a3d5f5d622800b1d27a34f60f756d01cde99837d33caa278868101efed968d18ff4ae7b25bed532d3e11189108817364e3f3887de67157c4e72be3068b
 */
export const loginWithToken = createAppAsyncThunk<LoginWithTokenResponse, LoginWithTokenRequest>(
	"auth/loginWithToken",
	async ({ queryString }, { dispatch, extra, rejectWithValue }) => {
		try {
			if (![TokenKeys.AW_TOKEN, TokenKeys.AW_REFRESH_TOKEN].every(token => queryString.includes(token))) {
				return rejectWithValue("Invalid query string");
			}

			const queryStringWithoutQuestionMark = queryString.replace('?', '');
			const awAuthToken = queryStringWithoutQuestionMark.split('&')[0].split('=')?.[1];
			const awAuthTokenRefresh = queryStringWithoutQuestionMark.split('&')[1].split('=')?.[1];

			extra.localStorage.setItem(TokenKeys.AW_TOKEN, awAuthToken);
			extra.localStorage.setItem(TokenKeys.AW_REFRESH_TOKEN, awAuthTokenRefresh);

			await dispatch(loadProfile()).unwrap();

			extra.navigationService.navigate(homePrefix);

			return {
				awToken: awAuthToken,
				awRefreshToken: awAuthTokenRefresh
			};

		} catch (e) {
			dispatch(displayFrontErrorToast({ message: e as string }));
			return rejectWithValue(e);
		}
	}
)
